// Field & column config for each admin collection.
// types: text, textarea, number, select, list (comma or newline), tags, bool, richtext

export const SCHEMAS = {
  jobs: {
    title: "Jobs",
    editable: true,
    columns: ["title", "location", "employment_type", "status", "views"],
    statusField: "status",
    statusOptions: ["draft", "pending", "published", "rejected", "closed"],
    fields: [
      { k: "title", label: "Job Title", type: "text", required: true },
      { k: "location", label: "Location", type: "text", required: true },
      { k: "industry", label: "Industry", type: "text" },
      { k: "category", label: "Category", type: "text" },
      { k: "employment_type", label: "Employment Type", type: "select", options: ["Full-time", "Part-time", "Contract", "Temporary", "Internship"] },
      { k: "salary_min", label: "Salary Min (₹/month)", type: "number" },
      { k: "salary_max", label: "Salary Max (₹/month)", type: "number" },
      { k: "experience", label: "Experience", type: "text" },
      { k: "education", label: "Education", type: "text" },
      { k: "qualification", label: "Qualification", type: "text" },
      { k: "vacancies", label: "Vacancies", type: "number" },
      { k: "working_hours", label: "Working Hours", type: "text" },
      { k: "deadline", label: "Application Deadline", type: "text" },
      { k: "skills", label: "Skills", type: "tags" },
      { k: "description", label: "Job Description", type: "textarea" },
      { k: "responsibilities", label: "Responsibilities (one per line)", type: "list" },
      { k: "requirements", label: "Requirements (one per line)", type: "list" },
      { k: "benefits", label: "Benefits (one per line)", type: "list" },
      { k: "status", label: "Status", type: "select", options: ["draft", "pending", "published", "rejected", "closed"] },
    ],
  },
  interviews: {
    title: "Interviews",
    editable: true,
    columns: ["candidate_name", "job", "date", "status"],
    statusField: "status",
    statusOptions: ["Scheduled", "Completed", "Rescheduled", "Cancelled", "Selected", "Rejected"],
    fields: [
      { k: "candidate_name", label: "Candidate Name", type: "text", required: true },
      { k: "candidate_email", label: "Candidate Email (for alert)", type: "text", required: true },
      { k: "employer", label: "Employer / Company", type: "text" },
      { k: "job", label: "Job Role", type: "text" },
      { k: "date", label: "Date", type: "text" },
      { k: "time", label: "Time", type: "text" },
      { k: "mode", label: "Mode", type: "select", options: ["In-person", "Phone", "Video"] },
      { k: "location", label: "Location / Meeting Link", type: "text" },
      { k: "recruiter", label: "Recruiter", type: "text" },
      { k: "notes", label: "Notes", type: "textarea" },
      { k: "status", label: "Status", type: "select", options: ["Scheduled", "Completed", "Rescheduled", "Cancelled", "Selected", "Rejected"] },
    ],
  },
  blogs: {
    title: "Blog Posts",
    editable: true,
    columns: ["title", "category", "author", "status"],
    statusField: "status",
    statusOptions: ["draft", "published"],
    fields: [
      { k: "title", label: "Title", type: "text", required: true },
      { k: "category", label: "Category", type: "select", options: ["Recruitment", "HR", "Jobs", "Career Advice", "Interview Tips", "Resume Tips", "Manpower", "Hiring", "Workplace", "Industry Updates"] },
      { k: "author", label: "Author", type: "text" },
      { k: "excerpt", label: "Excerpt", type: "textarea" },
      { k: "content", label: "Content", type: "textarea", big: true },
      { k: "featured_image", label: "Featured Image URL", type: "text" },
      { k: "tags", label: "Tags", type: "tags" },
      { k: "seo_title", label: "SEO Title", type: "text" },
      { k: "meta_description", label: "Meta Description", type: "textarea" },
      { k: "status", label: "Status", type: "select", options: ["draft", "published"] },
    ],
  },
  services: {
    title: "Services", editable: true, columns: ["name", "slug", "order"],
    fields: [
      { k: "name", label: "Name", type: "text", required: true },
      { k: "slug", label: "Slug", type: "text" },
      { k: "icon", label: "Icon key", type: "text" },
      { k: "short", label: "Short Description", type: "textarea" },
      { k: "description", label: "Full Description", type: "textarea", big: true },
      { k: "order", label: "Order", type: "number" },
      { k: "seo_title", label: "SEO Title", type: "text" },
      { k: "meta_description", label: "Meta Description", type: "textarea" },
    ],
  },
  industries: {
    title: "Industries", editable: true, columns: ["name", "slug", "order"],
    fields: [
      { k: "name", label: "Name", type: "text", required: true },
      { k: "slug", label: "Slug", type: "text" },
      { k: "description", label: "Description", type: "textarea" },
      { k: "order", label: "Order", type: "number" },
      { k: "seo_title", label: "SEO Title", type: "text" },
      { k: "meta_description", label: "Meta Description", type: "textarea" },
    ],
  },
  locations: {
    title: "Locations", editable: true, columns: ["name", "district", "order"],
    fields: [
      { k: "name", label: "Name", type: "text", required: true },
      { k: "slug", label: "Slug", type: "text" },
      { k: "district", label: "District", type: "text" },
      { k: "intro", label: "Intro", type: "textarea" },
      { k: "order", label: "Order", type: "number" },
      { k: "seo_title", label: "SEO Title", type: "text" },
      { k: "meta_description", label: "Meta Description", type: "textarea" },
    ],
  },
  faqs: {
    title: "FAQs", editable: true, columns: ["question", "order"],
    fields: [
      { k: "question", label: "Question", type: "text", required: true },
      { k: "answer", label: "Answer", type: "textarea" },
      { k: "order", label: "Order", type: "number" },
    ],
  },
  testimonials: {
    title: "Testimonials", editable: true, columns: ["name", "role", "rating"],
    fields: [
      { k: "name", label: "Name", type: "text", required: true },
      { k: "role", label: "Role / Company", type: "text" },
      { k: "text", label: "Testimonial", type: "textarea" },
      { k: "rating", label: "Rating (1-5)", type: "number" },
      { k: "order", label: "Order", type: "number" },
    ],
  },
  applications: {
    title: "Applications", editable: false, columns: ["name", "job_title", "phone", "status"],
    statusField: "status", statusOptions: ["Applied", "Under Review", "Shortlisted", "Interview Scheduled", "Selected", "Rejected", "Joined"],
    fields: [
      { k: "name", label: "Name", type: "text" }, { k: "email", label: "Email", type: "text" },
      { k: "phone", label: "Phone", type: "text" }, { k: "job_title", label: "Job", type: "text" },
      { k: "location", label: "Location", type: "text" }, { k: "experience", label: "Experience", type: "text" },
      { k: "cover_note", label: "Cover Note", type: "textarea" },
      { k: "status", label: "Status", type: "select", options: ["Applied", "Under Review", "Shortlisted", "Interview Scheduled", "Selected", "Rejected", "Joined"] },
    ],
    fileField: "resume_file_id",
  },
  candidates: {
    title: "Candidates (Resume Database)", editable: false, columns: ["name", "preferred_job", "preferred_location", "crm_stage"],
    statusField: "crm_stage", statusOptions: ["New", "Verified", "Shortlisted", "Interview", "Selected", "Joined", "Rejected"],
    fields: [
      { k: "name", label: "Name", type: "text" }, { k: "email", label: "Email", type: "text" },
      { k: "phone", label: "Phone", type: "text" }, { k: "current_location", label: "Current Location", type: "text" },
      { k: "qualification", label: "Qualification", type: "text" }, { k: "experience", label: "Experience", type: "text" },
      { k: "preferred_job", label: "Preferred Job", type: "text" }, { k: "preferred_location", label: "Preferred Location", type: "text" },
      { k: "expected_salary", label: "Expected Salary", type: "text" }, { k: "skills", label: "Skills", type: "tags" },
      { k: "crm_stage", label: "CRM Stage", type: "select", options: ["New", "Verified", "Shortlisted", "Interview", "Selected", "Joined", "Rejected"] },
    ],
    fileField: "resume_file_id",
  },
  leads: {
    title: "Hiring Leads / Requirements", editable: false, columns: ["company", "job_role", "location", "crm_stage"],
    statusField: "crm_stage", statusOptions: ["New", "Contacted", "Requirement Received", "Proposal", "Active", "Closed"],
    fields: [
      { k: "company", label: "Company", type: "text" }, { k: "contact_person", label: "Contact", type: "text" },
      { k: "phone", label: "Phone", type: "text" }, { k: "email", label: "Email", type: "text" },
      { k: "industry", label: "Industry", type: "text" }, { k: "location", label: "Location", type: "text" },
      { k: "job_role", label: "Job Role", type: "text" }, { k: "vacancies", label: "Vacancies", type: "text" },
      { k: "salary_range", label: "Salary Range", type: "text" }, { k: "additional", label: "Additional", type: "textarea" },
      { k: "crm_stage", label: "CRM Stage", type: "select", options: ["New", "Contacted", "Requirement Received", "Proposal", "Active", "Closed"] },
    ],
  },
  employers: {
    title: "Employers", editable: false, columns: ["company", "email", "phone", "crm_stage"],
    fields: [{ k: "company", label: "Company", type: "text" }, { k: "email", label: "Email", type: "text" }, { k: "phone", label: "Phone", type: "text" }],
  },
  contacts: {
    title: "Enquiries", editable: false, columns: ["name", "email", "subject"],
    fields: [
      { k: "name", label: "Name", type: "text" }, { k: "email", label: "Email", type: "text" },
      { k: "phone", label: "Phone", type: "text" }, { k: "subject", label: "Subject", type: "text" },
      { k: "message", label: "Message", type: "textarea" },
    ],
  },
};
